<template>
  <div>
    <div class="two">
      <news
        style="width:860px;margin-right:20px"
        more-url="/main?type=1&selected=9&page=1"
        url="home/HomeGetSzNews"
        :param="{top:8,type:7}"
        text="工作交流"
      />
      <oneCol
        style="flex:1;"
        more-url="/main?type=1&selected=12&page=1"
        url="home/HomeGetSzNews"
        :param="{top:5,type:14}"
        text="志愿活动"
      />

    </div>
    <div class="two">
      <oneCol
        style="flex:1;margin-right:20px"
        more-url="/main?type=5&selected=1&page=1"
        url="home/HomeGetSzNews"
        :param="{top:5,type:11}"
        text="帮扶政策"
      />
      <news
        style="width:860px"
        more-url="/main?type=1&selected=10&page=1"
        url="home/HomeGetSzNews"
        :param="{top:5,type:9}"
        text="红色文艺"
      />

    </div>
  </div>
</template>

<script>
import news from '../leftImgNews.vue'
import oneCol from '../oneCol.vue'
export default {
  components: {
    news, oneCol
  },
  data() {
    return {
    }
  },

  methods: {
  }
}
</script>

<style lang="scss" scoped>
.two {
  display: flex;
}
.rightContent {
  img {
    width: 100%;
    height: 200px;
  }

  .twoItem {
    display: flex;
    justify-content: space-between;
    margin-top: 22px;
    .item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 199px;
      height: 132px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 8px;
      padding: 31px 0 21px 0;
    }
    .item > div > img {
      margin-right: 10px;
      width: 50px;
      height: 50px;
    }
    .item > div > span {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
    }
    .item > span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
    }
  }
}
</style>
